import { useAppSelector } from '@/shared/hooks';

import type { LiveSession } from '../model';

import { useLiveSession } from './useLiveSession';

// The live session of the encounter while it records, or waits to be
// finished after an interruption: its recording page shows the recording in
// place of the documents, and the corner window gives way to it there.
export const useRecordingSession = (
  encounterId: string | undefined,
): LiveSession | null => {
  const session = useLiveSession();
  const recording = useAppSelector(
    ({ transcriptor }) =>
      !!encounterId &&
      transcriptor.recording.consultationId === encounterId &&
      (transcriptor.recording.isRecording ||
        transcriptor.recording.isInterrupted),
  );

  return recording && session?.meta.encounterId === encounterId
    ? session
    : null;
};
